/* ============================================
   EWB-DOKUMENT-FINDER - GunsofKosta
   JavaScript Logik
   ============================================ */

(function() {
  'use strict';

  // ============================================
  // SVG ICONS
  // ============================================
  const ICONS = {
    // Header & Navigation
    target: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><circle cx="12" cy="12" r="6"/><circle cx="12" cy="12" r="2"/></svg>`,
    close: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>`,
    arrowLeft: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="19" y1="12" x2="5" y2="12"/><polyline points="12 19 5 12 12 5"/></svg>`,
    check: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>`,
    checkCircle: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/><polyline points="22 4 12 14.01 9 11.01"/></svg>`,
    info: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><line x1="12" y1="16" x2="12" y2="12"/><line x1="12" y1="8" x2="12.01" y2="8"/></svg>`,
    warning: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/><line x1="12" y1="9" x2="12" y2="13"/><line x1="12" y1="17" x2="12.01" y2="17"/></svg>`,
    copy: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="9" y="9" width="13" height="13" rx="2" ry="2"/><path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"/></svg>`,
    mail: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/><polyline points="22,6 12,13 2,6"/></svg>`,
    
    // Käufergruppen
    sportschuetze: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><circle cx="12" cy="12" r="6"/><circle cx="12" cy="12" r="2"/><line x1="12" y1="2" x2="12" y2="6"/><line x1="12" y1="18" x2="12" y2="22"/><line x1="2" y1="12" x2="6" y2="12"/><line x1="18" y1="12" x2="22" y2="12"/></svg>`,
    jaeger: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" fill="currentColor"><path d="M490.677,138.671l-63.579-0.013l4.374-21.869c0.651-0.151,1.301-0.33,1.947-0.546l64-21.333c11.177-3.726,17.218-15.807,13.492-26.985c-3.726-11.177-15.807-17.218-26.985-13.492l-42.84,14.28l6.505-32.524c2.311-11.553-5.182-22.792-16.735-25.103c-11.553-2.311-22.792,5.182-25.103,16.735l-20.068,100.339l-14.279,14.293l-40.788,20.394l10.084-40.335c2.858-11.43-4.092-23.013-15.522-25.87c-11.43-2.858-23.013,4.092-25.87,15.522l-21.333,85.333c-0.021,0.083-0.035,0.167-0.055,0.251c-0.032,0.133-0.058,0.266-0.087,0.399c-0.11,0.505-0.202,1.013-0.275,1.524c-0.016,0.111-0.037,0.22-0.051,0.331c-0.071,0.562-0.114,1.126-0.14,1.692c-0.009,0.193-0.014,0.386-0.018,0.579c-0.003,0.133-0.012,0.265-0.012,0.397v42.667c0,1.955,0.285,3.84,0.778,5.639c-7.022,1.391-14.473,2.111-22.111,2.111c-7.626,0-15.065-0.718-22.111-2.113c0.492-1.798,0.777-3.683,0.777-5.637v-42.667c0-0.133-0.01-0.265-0.012-0.397c-0.004-0.193-0.009-0.386-0.018-0.579c-0.026-0.566-0.069-1.131-0.14-1.692c-0.014-0.111-0.035-0.221-0.051-0.331c-0.073-0.511-0.165-1.019-0.275-1.524c-0.029-0.133-0.055-0.267-0.087-0.399c-0.02-0.083-0.034-0.168-0.055-0.251l-21.333-85.333c-2.858-11.43-14.44-18.38-25.87-15.522c-11.43,2.858-18.38,14.44-15.522,25.87l10.084,40.335l-40.788-20.394l-14.279-14.293L106.258,27.821c-2.311-11.553-13.55-19.046-25.103-16.735S62.109,24.635,64.42,36.188l6.505,32.524l-42.84-14.28C16.908,50.707,4.826,56.748,1.101,67.925C-2.625,79.103,3.415,91.184,14.593,94.91l64,21.333c0.647,0.216,1.296,0.395,1.947,0.546l4.374,21.869l-63.579,0.013c-11.782,0.002-21.331,9.555-21.329,21.338c0.002,11.782,9.556,21.331,21.338,21.329l101.586-0.02l69.077,34.538v29.482c0,0.005,0.001,0.01,0.001,0.014c-13.755,0.182-27.137,3.909-37.237,11.183c-6.978,4.996-12.789,11.299-17.197,18.834c-14.39-12.855-32.01-21.74-51.228-25.159c-14.018-2.474-29.142-3.165-45.408-1.838c-16.63,1.357-25.335,20.42-15.47,33.876c2.505,3.418,6.553,9.593,10.577,17.033c2.925,5.407,5.321,10.613,7.003,15.354c9.722,27.415,29.7,49.149,55.893,58.539c12.926,4.615,34.445,6.997,52.964,6.433c0.351,0.443,0.685,0.891,1.043,1.331c13.529,16.659,21.915,32.338,22.436,42.708c-1.036,12.075,0.356,24.866,6.182,37.576c11.531,25.156,36.717,40.124,74.441,40.124s62.91-14.968,74.441-40.124c5.826-12.71,7.218-25.501,6.25-36.825c0.452-11.122,8.839-26.801,22.376-43.47c0.355-0.437,0.687-0.882,1.035-1.321c18.518,0.564,40.035-1.817,52.938-6.424c26.22-9.399,46.197-31.133,55.92-58.55c1.681-4.738,4.078-9.944,7.002-15.351c4.024-7.439,8.071-13.615,10.577-17.033c9.865-13.456,1.16-32.519-15.47-33.876c-16.266-1.327-31.39-0.636-45.379,1.833c-19.241,3.423-36.872,12.314-51.268,25.177c-3.719-6.353-8.447-11.851-14.054-16.451c-10.556-8.659-25.244-13.302-40.369-13.566c0-0.009,0.001-0.017,0.001-0.026v-29.482l69.077-34.538l101.586,0.02c11.782,0.002,21.335-9.547,21.338-21.329C512.008,148.227,502.459,138.674,490.677,138.671z M113.312,332.999c-13.468-4.828-24.419-16.742-30.053-32.628c-0.93-2.621-1.971-5.26-3.114-7.914c19.017,3.814,35.689,17.07,44.831,35.628l2.769,5.616l0.576,2.263C122.136,335.252,116.728,334.219,113.312,332.999z M387.034,328.092c9.14-18.555,25.8-31.808,44.833-35.634c-1.143,2.653-2.184,5.291-3.113,7.91c-5.635,15.889-16.586,27.803-30.08,32.64c-3.404,1.215-8.804,2.246-14.982,2.957l0.576-2.264L387.034,328.092z M341.339,313.952v1.579c0,12.761-5.153,25.911-15.379,38.488c-19.721,24.285-32.024,47.709-32.024,70.632l0.248,3.242c0.396,4.757-0.235,10.556-2.523,15.549c-4.329,9.444-14.075,15.236-35.655,15.236s-31.326-5.792-35.655-15.236c-2.289-4.993-2.92-10.792-2.525-15.413c0.022-0.261,0.249-3.378,0.249-3.378c0-22.923-12.302-46.347-32.016-70.622c-10.234-12.587-15.387-25.737-15.387-38.498v-1.579c0-12.208,3.38-18.748,8.985-22.761c2.77-1.995,8.643-3.429,15.023-3.157c9.827,0.415,17.124,1.435,22.134,2.774c12.484,3.301,25.714,4.947,39.192,4.947c13.478,0,26.708-1.646,39.139-4.933c4.994-1.339,12.248-2.356,22.049-2.789c6.834-0.288,13.222,1.509,16.12,3.885C338.307,296.015,341.339,302.501,341.339,313.952z"/></svg>`,
    sammler: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="3" width="7" height="7" rx="1"/><rect x="14" y="3" width="7" height="7" rx="1"/><rect x="14" y="14" width="7" height="7" rx="1"/><rect x="3" y="14" width="7" height="7" rx="1"/></svg>`,
    behoerde: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="16" y1="13" x2="8" y2="13"/><line x1="16" y1="17" x2="8" y2="17"/><line x1="10" y1="9" x2="8" y2="9"/></svg>`,
    euAusland: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><line x1="2" y1="12" x2="22" y2="12"/><path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"/></svg>`,
    
    // Waffentypen - SVGRepo Icons
    kurzwaffe: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 15.847 15.847" fill="currentColor"><path d="M15.847,5.228V4.052h-0.065V2.931h-0.064V2.534H15.26V2.93c0,0-11.083,0.078-13.018,0c-0.296,0-1.986,0.167-0.291,2.773c0,0,0.77,1.168-0.285,2.471c-1.041,1.284-1.51,3.885-1.632,4.671H0v0.468h4.803v-0.468v-0.43c-2.075,0.382,1.434-4.447,1.278-3.634c0.113,0.029,0.23,0.047,0.352,0.047h1.25c0.772,0,1.797-0.826,1.797-1.599c0-0.335-0.118-0.642-0.314-0.883h6.185l0.2-0.736h0.262V5.254H15.77l0.011-0.026H15.847z M7.685,8.144h-1.25c-0.092,0-0.181-0.015-0.265-0.04c0.073-0.429,0.129-0.813,0.169-1.112c0.105,0.347,0.31,0.71,0.713,0.867C7.08,7.87,7.109,7.875,7.138,7.875c0.094,0,0.184-0.058,0.221-0.15c0.047-0.123-0.014-0.26-0.136-0.308c-0.417-0.162-0.5-0.792-0.516-1.068h1.205c0.393,0.102,0.686,0.459,0.686,0.883C8.598,7.734,8.188,8.144,7.685,8.144z M14.098,5.612H7.924l1.072-0.357h5.102C14.098,5.255,14.098,5.612,14.098,5.612z"/></svg>`,
    langwaffe: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64" fill="currentColor"><path d="M59.2,53.5L45.7,40l0.9-0.9h2.7c0.6,0,1.1-0.5,1.1-1.1s-0.5-1.1-1.1-1.1h-2.7L34.2,24.4L14.1,4.4l1-1c0.4-0.4,0.4-1.1,0-1.6c-0.4-0.4-1.1-0.4-1.6,0l-1,1L10,0.3c-0.4-0.4-1.1-0.4-1.6,0L4.8,4c-0.4,0.4-0.4,1.1,0,1.6l23.3,23.3l-0.3,0.3c-0.4,0.4-0.6,1-0.6,1.6c0,0.6,0.2,1.1,0.6,1.6l7.6,7.6l-1.3,1.3c-0.6,0.6-1,1.5-1,2.3c0,0.9,0.3,1.7,1,2.3l2.1,2.1c0.2,0.2,0.5,0.3,0.8,0.3c0.3,0,0.6-0.1,0.8-0.3l0.7-0.7l7.9,13.9c0,0.1,0.1,0.2,0.2,0.2l2.4,2.4c0.2,0.2,0.5,0.3,0.8,0.3c0.3,0,0.6-0.1,0.8-0.3l8.7-8.7C59.6,54.6,59.6,53.9,59.2,53.5z M9.3,2.7l22.6,22.6l-2.1,2.1L7.2,4.8L9.3,2.7z M33.4,26.8L44.6,38l-1.2,1.2l-2.7,2.7l-2.9-2.9l-8.4-8.4L33.4,26.8z M35.7,44.3c-0.2-0.2-0.3-0.5-0.3-0.8s0.1-0.6,0.3-0.8c0,0,0,0,0,0l1.3-1.3l2.1,2.1L38,44.6l-1,1L35.7,44.3z M49.8,61.3l-1.5-1.5l-8.1-14.3l4-4l12.7,12.7L49.8,61.3z"/></svg>`,
    halbautomat: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 458.88 458.88" fill="currentColor"><path d="M138.074,188.486h32.615c3.038,0,5.5-2.462,5.5-5.5s-2.462-5.5-5.5-5.5h-32.615c-3.038,0-5.5,2.462-5.5,5.5S135.036,188.486,138.074,188.486z"/><path d="M420.525,182.133v3.542h-10.049V167.26h-11v18.416h-33.803l-10.87-17.937h-34.381v-5.835H133.992c-5.489,0-10.77,2.593-14.125,6.936l-6.961,9.009l-103.49-0.006c-2.543,0.002-4.926,1.002-6.709,2.815s-2.744,4.212-2.704,6.755l0.583,37.299c0.046,2.952,1.431,5.655,3.801,7.416c1.652,1.228,3.604,1.866,5.598,1.866c0.866,0,1.739-0.121,2.599-0.365l86.193-24.5c1.438-0.075,15.429-0.8,22.324-0.901c1.469,5.21,1.168,10.847-0.914,15.887l-11.024,26.689l23.424,9.863l19.915-37.209h10.035c10.006,0,18.377-7.129,20.303-16.574l5.744-0.185c-0.353,31.484,10.489,61.829,30.887,86.076l3.536,4.203l29.709-24.969l-3.54-4.21c-14.575-17.335-22.338-39.782-21.736-62.353l92.982-3v-5.769h100.104v3.546h38.355v-18.088H420.525z M11.551,222.485l-0.526-33.643l81.831-0.062v10.594L11.551,222.485z M103.856,197.861v-9.012h14.451l10.264-13.284c1.288-1.667,3.314-2.662,5.421-2.662h175.429v3.355h-37.535c-10.536,0-19.2,7.424-21.07,17.426C250.816,193.685,109.626,197.586,103.856,197.861z M127.617,246.639l-4.117-1.734l6.853-16.592c2.648-6.409,3.305-13.48,2-20.221l16.072-0.331L127.617,246.639z M162.535,212.457h-4.148l2.606-4.87l10.138-0.327C169.501,210.347,166.262,212.457,162.535,212.457z M237.33,270.572l-2.38,2.002c-3.502,2.946-7.004,5.891-10.507,8.834c-16.562-21.583-25.267-47.872-24.857-75.065l16.836-0.543C215.954,228.992,223.375,252.024,237.33,270.572z M262.377,193.312c1.651-3.594,5.271-6.053,9.509-6.053h37.535v4.535L262.377,193.312z M320.421,178.739h28.185l4.204,6.937h-32.389V178.739z"/></svg>`,
    schalldaempfer: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="2" y="9" width="20" height="6" rx="3"/><line x1="6" y1="9" x2="6" y2="15"/><line x1="10" y1="9" x2="10" y2="15"/><line x1="14" y1="9" x2="14" y2="15"/><line x1="18" y1="9" x2="18" y2="15"/></svg>`,
    munition: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 503 503" fill="currentColor"><path d="M334.528,435.039V183.236c0-5.036-3.357-8.393-8.393-8.393v-33.574c0-54.557-26.02-107.436-70.505-141.01c-3.357-1.679-6.715-1.679-10.072,0c-44.485,33.574-70.505,86.452-70.505,141.01v33.574c-5.036,0-8.393,3.357-8.393,8.393v251.803c0,5.036,3.357,8.393,8.393,8.393v8.393c-5.036,0-8.393,3.357-8.393,8.393v33.574c0,5.036,3.357,8.393,8.393,8.393h151.082c5.036,0,8.393-3.357,8.393-8.393V460.22c0-5.036-3.357-8.393-8.393-8.393v-8.393C331.17,443.433,334.528,440.075,334.528,435.039z M183.446,191.63h134.295v235.016H183.446V191.63z M191.839,141.269c0-47.843,21.823-93.167,58.754-123.384c36.931,30.216,58.754,75.541,58.754,123.384v33.574H191.839V141.269z M317.741,485.4H183.446v-16.787h134.295V485.4z M309.348,451.826H191.839v-8.393h117.508V451.826z"/></svg>`,
    
    // Dokumente
    perso: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="2" y="5" width="20" height="14" rx="2"/><line x1="2" y1="10" x2="22" y2="10"/><circle cx="8" cy="15" r="2"/><path d="M14 13h4"/><path d="M14 17h4"/></svg>`,
    wbkGruen: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="3" width="18" height="18" rx="2"/><path d="M9 12l2 2 4-4"/><line x1="3" y1="9" x2="21" y2="9"/></svg>`,
    wbkGelb: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="3" width="18" height="18" rx="2"/><circle cx="12" cy="14" r="3"/><line x1="3" y1="9" x2="21" y2="9"/></svg>`,
    wbkRot: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="3" width="18" height="18" rx="2"/><path d="M9 14h6"/><path d="M12 11v6"/><line x1="3" y1="9" x2="21" y2="9"/></svg>`,
    jagdschein: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><path d="M9 15l2 2 4-4"/></svg>`,
    nwrId: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="4" width="18" height="16" rx="2"/><path d="M7 8h.01"/><path d="M7 12h.01"/><path d="M7 16h.01"/><path d="M11 8h6"/><path d="M11 12h6"/><path d="M11 16h6"/></svg>`,
    dienstausweis: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 2l3 6 7 1-5 5 1 7-6-3-6 3 1-7-5-5 7-1z"/></svg>`,
    einfuhr: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><path d="M12 18v-6"/><path d="M9 15l3 3 3-3"/></svg>`,
    munitionsschein: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><circle cx="12" cy="15" r="3"/></svg>`
  };

  // ============================================
  // DATA - Dokumenten-Matrix
  // ============================================
  const DOKUMENTE = {
    perso: { 
      id: 'perso', 
      name: 'Personalausweis', 
      desc: 'Vorder- und Rückseite, gut lesbar', 
      icon: 'perso' 
    },
    wbkGruenVor: { 
      id: 'wbkGruenVor', 
      name: 'Grüne WBK mit Voreintrag', 
      desc: 'Gültiger Voreintrag für den Waffentyp erforderlich', 
      icon: 'wbkGruen' 
    },
    wbkGruen: { 
      id: 'wbkGruen', 
      name: 'Grüne WBK', 
      desc: 'Titelseite gut lesbar', 
      icon: 'wbkGruen' 
    },
    wbkGelb: { 
      id: 'wbkGelb', 
      name: 'Gelbe WBK (§14)', 
      desc: 'Sportschützen-Waffenbesitzkarte', 
      icon: 'wbkGelb' 
    },
    wbkRot: { 
      id: 'wbkRot', 
      name: 'Rote WBK', 
      desc: 'Mit entsprechendem Sammelgebiet', 
      icon: 'wbkRot' 
    },
    wbkMunition: { 
      id: 'wbkMunition', 
      name: 'WBK mit Munitionseintrag', 
      desc: 'Gültiger Eintrag für das Kaliber', 
      icon: 'wbkGruen' 
    },
    jagdschein: { 
      id: 'jagdschein', 
      name: 'Jagdschein (gültig)', 
      desc: 'Aktuelles Jagdjahr, nicht abgelaufen', 
      icon: 'jagdschein' 
    },
    pId: { 
      id: 'pId', 
      name: 'NWR-ID: P-ID (Person)', 
      desc: '21-stellige Nummer, beginnt mit "P"', 
      icon: 'nwrId',
      hasInfo: true 
    },
    eId: { 
      id: 'eId', 
      name: 'NWR-ID: E-ID (Erlaubnis)', 
      desc: '21-stellige Nummer, beginnt mit "E"', 
      icon: 'nwrId',
      hasInfo: true 
    },
    dienstausweis: { 
      id: 'dienstausweis', 
      name: 'Dienst-/Personalausweis', 
      desc: 'Behördlicher Ausweis', 
      icon: 'dienstausweis' 
    },
    dienstwaffen: { 
      id: 'dienstwaffen', 
      name: 'Dienstwaffenerlaubnis', 
      desc: 'Oder Ersatzbescheinigung der Dienststelle', 
      icon: 'behoerde' 
    },
    einfuhr: { 
      id: 'einfuhr', 
      name: 'Einfuhrgenehmigung', 
      desc: 'Behördliche Genehmigung Ihres Landes', 
      icon: 'einfuhr' 
    },
    munitionsschein: { 
      id: 'munitionsschein', 
      name: 'Munitionserwerbsschein', 
      desc: 'Für die entsprechenden Kaliber', 
      icon: 'munitionsschein' 
    }
  };

  const KAEUFER = {
    sportschuetze: {
      id: 'sportschuetze',
      label: 'Sportschütze',
      icon: 'sportschuetze',
      waffen: ['kurzwaffe', 'langwaffe', 'halbautomat', 'munition']
    },
    jaeger: {
      id: 'jaeger',
      label: 'Jäger',
      icon: 'jaeger',
      waffen: ['kurzwaffe', 'langwaffe', 'halbautomat', 'schalldaempfer', 'munition']
    },
    sammler: {
      id: 'sammler',
      label: 'Sammler',
      icon: 'sammler',
      waffen: ['kurzwaffe', 'langwaffe', 'halbautomat', 'munition']
    },
    behoerde: {
      id: 'behoerde',
      label: 'Behörde',
      sublabel: 'Polizei, Bundeswehr',
      icon: 'behoerde',
      waffen: ['dienstwaffe']
    },
    euAusland: {
      id: 'euAusland',
      label: 'EU-Ausland',
      sublabel: 'AT, LU, FR etc.',
      icon: 'euAusland',
      waffen: ['kurzwaffe', 'langwaffe', 'halbautomat', 'munition']
    }
  };

  const WAFFEN = {
    kurzwaffe: {
      id: 'kurzwaffe',
      label: 'Kurzwaffe',
      sublabel: 'Pistole, Revolver',
      icon: 'kurzwaffe'
    },
    langwaffe: {
      id: 'langwaffe',
      label: 'Langwaffe',
      sublabel: 'Repetierer, Einzellader',
      icon: 'langwaffe'
    },
    halbautomat: {
      id: 'halbautomat',
      label: 'Halbautomat',
      sublabel: 'Büchse, Flinte',
      icon: 'halbautomat'
    },
    schalldaempfer: {
      id: 'schalldaempfer',
      label: 'Schalldämpfer',
      sublabel: '',
      icon: 'schalldaempfer'
    },
    munition: {
      id: 'munition',
      label: 'Munition',
      sublabel: '',
      icon: 'munition'
    },
    waffe: {
      id: 'waffe',
      label: 'Waffe',
      sublabel: 'Lt. Berechtigung',
      icon: 'kurzwaffe'
    },
    dienstwaffe: {
      id: 'dienstwaffe',
      label: 'Dienstwaffe',
      sublabel: '',
      icon: 'kurzwaffe'
    }
  };

  // Dokumenten-Matrix: Welche Dokumente für welche Kombination
  const MATRIX = {
    sportschuetze: {
      kurzwaffe: ['perso', 'wbkGruenVor', 'pId', 'eId'],
      langwaffe: ['perso', 'wbkGelb', 'pId', 'eId'],
      halbautomat: ['perso', 'wbkGruenVor', 'pId', 'eId'],
      munition: ['perso', 'wbkMunition', 'pId', 'eId']
    },
    jaeger: {
      kurzwaffe: ['perso', 'jagdschein', 'wbkGruen', 'pId', 'eId'],
      langwaffe: ['perso', 'jagdschein', 'wbkGruen', 'pId', 'eId'],
      halbautomat: ['perso', 'jagdschein', 'wbkGruen', 'pId', 'eId'],
      schalldaempfer: ['perso', 'jagdschein', 'wbkGruen', 'pId', 'eId'],
      munition: ['perso', 'jagdschein', 'pId', 'eId']
    },
    sammler: {
      kurzwaffe: ['perso', 'wbkRot', 'pId', 'eId'],
      langwaffe: ['perso', 'wbkRot', 'pId', 'eId'],
      halbautomat: ['perso', 'wbkRot', 'pId', 'eId'],
      munition: ['perso', 'munitionsschein', 'pId', 'eId']
    },
    behoerde: {
      dienstwaffe: ['dienstausweis', 'dienstwaffen']
    },
    euAusland: {
      kurzwaffe: ['perso', 'einfuhr'],
      langwaffe: ['perso', 'einfuhr'],
      halbautomat: ['perso', 'einfuhr'],
      munition: ['perso', 'einfuhr']
    }
  };

  // Sonderhinweise
  const HINWEISE = {
    jaeger_langwaffe: 'Bei Ersterwerb (Jungjäger ohne WBK): Nur Personalausweis + Jagdschein erforderlich.',
    jaeger_schalldaempfer: 'Bei Ersterwerb (Jungjäger ohne WBK): Nur Personalausweis + Jagdschein erforderlich.',
    sportschuetze_schalldaempfer: 'Schalldämpfer sind für Sportschützen nur mit Ausnahmegenehmigung erhältlich.'
  };

  // ============================================
  // STATE
  // ============================================
  let state = {
    step: 1,
    kaeufer: null,
    waffe: null
  };

  // ============================================
  // RENDER FUNCTIONS
  // ============================================
  
  function renderModal() {
    const modal = document.createElement('div');
    modal.className = 'ewb-modal-overlay';
    modal.id = 'ewbModal';
    modal.innerHTML = `
      <div class="ewb-modal">
        <div class="ewb-modal-header">
          <h2 class="ewb-modal-title">${ICONS.target} Dokumente-Finder</h2>
          <p class="ewb-modal-subtitle">Finden Sie heraus, welche Dokumente Sie benötigen</p>
          <button class="ewb-modal-close" onclick="EWBFinder.close()">${ICONS.close}</button>
        </div>
        
        <div class="ewb-progress">
          <div class="ewb-progress-step active" data-step="1">
            <div class="ewb-progress-circle">1</div>
            <span class="ewb-progress-label">Ich bin</span>
          </div>
          <div class="ewb-progress-line"></div>
          <div class="ewb-progress-step" data-step="2">
            <div class="ewb-progress-circle">2</div>
            <span class="ewb-progress-label">Kaufen</span>
          </div>
          <div class="ewb-progress-line"></div>
          <div class="ewb-progress-step" data-step="3">
            <div class="ewb-progress-circle">${ICONS.check}</div>
            <span class="ewb-progress-label">Ergebnis</span>
          </div>
        </div>
        
        <div class="ewb-modal-body" id="ewbContent">
          <!-- Content wird dynamisch eingefügt -->
        </div>
        
        <div class="ewb-modal-footer" id="ewbFooter">
          <button class="ewb-btn-back" onclick="EWBFinder.back()" style="visibility: hidden;">
            ${ICONS.arrowLeft} Zurück
          </button>
          <button class="ewb-btn-reset" onclick="EWBFinder.reset()">Neu starten</button>
        </div>
      </div>
    `;
    
    document.body.appendChild(modal);
    renderNWRTooltip();
    renderToast();
    
    return modal;
  }

  function renderNWRTooltip() {
    const tooltip = document.createElement('div');
    tooltip.innerHTML = `
      <div class="ewb-nwr-tooltip-overlay" id="ewbNwrOverlay" onclick="EWBFinder.closeNWRInfo()"></div>
      <div class="ewb-nwr-tooltip" id="ewbNwrTooltip">
        <button class="ewb-nwr-close" onclick="EWBFinder.closeNWRInfo()">${ICONS.close}</button>
        <h3 class="ewb-nwr-title">${ICONS.info} Was ist eine NWR-ID?</h3>
        <p class="ewb-nwr-text">
          Die NWR-ID ist Ihre eindeutige Identifikationsnummer im Nationalen Waffenregister. 
          Sie benötigen zwei IDs:
        </p>
        <ul class="ewb-nwr-text" style="margin-left: 20px;">
          <li><strong>P-ID</strong> = Personen-ID (beginnt mit "P")</li>
          <li><strong>E-ID</strong> = Erlaubnis-ID (beginnt mit "E")</li>
        </ul>
        <div class="ewb-nwr-diagram">
          <p class="ewb-nwr-example">E-2019-09-20-1234567-M</p>
          <div class="ewb-nwr-labels">
            <div class="ewb-nwr-label"><span>E</span>Typ</div>
            <div class="ewb-nwr-label"><span>2019-09-20</span>Datum</div>
            <div class="ewb-nwr-label"><span>1234567</span>Zähler</div>
            <div class="ewb-nwr-label"><span>M</span>Prüfziffer</div>
          </div>
        </div>
        <p class="ewb-nwr-where">
          <strong>Wo finde ich sie?</strong><br>
          Auf Ihrer WBK (Innenseite, am Rand) oder im Stammdatenblatt Ihrer Waffenbehörde.
        </p>
      </div>
    `;
    document.body.appendChild(tooltip);
  }

  function renderToast() {
    const toast = document.createElement('div');
    toast.className = 'ewb-toast';
    toast.id = 'ewbToast';
    toast.innerHTML = `${ICONS.checkCircle} E-Mail-Adresse kopiert!`;
    document.body.appendChild(toast);
  }

  function renderStep1() {
    const content = document.getElementById('ewbContent');
    content.innerHTML = `
      <h3 class="ewb-step-title">Ich bin...</h3>
      <div class="ewb-cards">
        ${Object.values(KAEUFER).map(k => `
          <div class="ewb-card" onclick="EWBFinder.selectKaeufer('${k.id}')">
            <div class="ewb-card-icon">${ICONS[k.icon]}</div>
            <p class="ewb-card-title">${k.label}</p>
            ${k.sublabel ? `<p class="ewb-card-subtitle">${k.sublabel}</p>` : ''}
          </div>
        `).join('')}
      </div>
    `;
    
    updateProgress(1);
    updateFooter();
  }

  function renderStep2() {
    const kaeufer = KAEUFER[state.kaeufer];
    const content = document.getElementById('ewbContent');
    
    content.innerHTML = `
      <h3 class="ewb-step-title">Ich möchte erwerben...</h3>
      <div class="ewb-cards">
        ${kaeufer.waffen.map(wId => {
          const w = WAFFEN[wId];
          return `
            <div class="ewb-card" onclick="EWBFinder.selectWaffe('${w.id}')">
              <div class="ewb-card-icon">${ICONS[w.icon]}</div>
              <p class="ewb-card-title">${w.label}</p>
              ${w.sublabel ? `<p class="ewb-card-subtitle">${w.sublabel}</p>` : ''}
            </div>
          `;
        }).join('')}
      </div>
    `;
    
    updateProgress(2);
    updateFooter();
  }

  function renderResult() {
    const kaeufer = KAEUFER[state.kaeufer];
    const waffe = WAFFEN[state.waffe];
    const dokIds = MATRIX[state.kaeufer][state.waffe];
    const hinweisKey = `${state.kaeufer}_${state.waffe}`;
    const hinweis = HINWEISE[hinweisKey];
    
    // NWR-IDs zusammenfassen
    const hasNwrIds = dokIds.includes('pId') || dokIds.includes('eId');
    const filteredDokIds = dokIds.filter(id => id !== 'pId' && id !== 'eId');
    
    const content = document.getElementById('ewbContent');
    
    content.innerHTML = `
      <div class="ewb-result active">
        <div class="ewb-result-header">
          <div class="ewb-result-icon">${ICONS.checkCircle}</div>
          <h3 class="ewb-result-title">Diese Dokumente benötigen Sie</h3>
          <p class="ewb-result-selection">${kaeufer.label} · ${waffe.label}</p>
        </div>
        
        <div class="ewb-checklist-simple">
          ${filteredDokIds.map((dokId, index) => {
            const dok = DOKUMENTE[dokId];
            return `
              <div class="ewb-doc-item">
                <span class="ewb-doc-number">${index + 1}</span>
                <div class="ewb-doc-content">
                  <p class="ewb-doc-name">${dok.name}</p>
                  <p class="ewb-doc-desc">${dok.desc}</p>
                </div>
              </div>
            `;
          }).join('')}
          
          ${hasNwrIds ? `
            <div class="ewb-doc-item">
              <span class="ewb-doc-number">${filteredDokIds.length + 1}</span>
              <div class="ewb-doc-content">
                <p class="ewb-doc-name">
                  NWR-IDs (P-ID + E-ID)
                  <button class="ewb-info-btn" onclick="EWBFinder.showNWRInfo()">${ICONS.info}</button>
                </p>
                <p class="ewb-doc-desc">Beide 21-stellige Nummern von Ihrer WBK</p>
              </div>
            </div>
          ` : ''}
        </div>
        
        ${hinweis ? `
          <div class="ewb-notice ewb-notice-warning">
            ${ICONS.warning}
            <p class="ewb-notice-text">${hinweis}</p>
          </div>
        ` : ''}
        
        <div class="ewb-action-box">
          <p class="ewb-action-title">Dokumente per E-Mail senden an:</p>
          <a href="mailto:info@gunsofkosta.de?subject=Dokumente%20zur%20Bestellung" class="ewb-email-button">
            ${ICONS.mail} info@gunsofkosta.de
          </a>
          <button class="ewb-copy-link" onclick="EWBFinder.copyEmail()">
            ${ICONS.copy} E-Mail-Adresse kopieren
          </button>
        </div>
        
        <p class="ewb-footnote">
          ${ICONS.info} <strong>Tipp:</strong> Falls keine NWR-IDs auf Ihrer WBK stehen, 
          senden Sie uns zusätzlich das Stammdatenblatt Ihrer Behörde.
        </p>
      </div>
    `;
    
    updateProgress(3);
    updateFooter();
  }

  function updateProgress(step) {
    const steps = document.querySelectorAll('.ewb-progress-step');
    const lines = document.querySelectorAll('.ewb-progress-line');
    
    steps.forEach((s, i) => {
      s.classList.remove('active', 'completed');
      if (i + 1 < step) {
        s.classList.add('completed');
      } else if (i + 1 === step) {
        s.classList.add('active');
      }
    });
    
    lines.forEach((l, i) => {
      l.classList.remove('completed');
      if (i + 1 < step) {
        l.classList.add('completed');
      }
    });
  }

  function updateFooter() {
    const backBtn = document.querySelector('.ewb-btn-back');
    if (state.step > 1) {
      backBtn.style.visibility = 'visible';
    } else {
      backBtn.style.visibility = 'hidden';
    }
  }

  // ============================================
  // PUBLIC API
  // ============================================
  window.EWBFinder = {
    init: function() {
      // Modal nur einmal erstellen
      if (!document.getElementById('ewbModal')) {
        renderModal();
      }
    },
    
    open: function() {
      this.init();
      this.reset();
      const modal = document.getElementById('ewbModal');
      modal.classList.add('active');
      document.body.style.overflow = 'hidden';
    },
    
    close: function() {
      const modal = document.getElementById('ewbModal');
      modal.classList.remove('active');
      document.body.style.overflow = '';
    },
    
    reset: function() {
      state = { step: 1, kaeufer: null, waffe: null };
      renderStep1();
    },
    
    back: function() {
      if (state.step === 2) {
        state.step = 1;
        state.kaeufer = null;
        renderStep1();
      } else if (state.step === 3) {
        state.step = 2;
        state.waffe = null;
        renderStep2();
      }
    },
    
    selectKaeufer: function(id) {
      state.kaeufer = id;
      state.step = 2;
      renderStep2();
    },
    
    selectWaffe: function(id) {
      state.waffe = id;
      state.step = 3;
      renderResult();
    },
    
    showNWRInfo: function() {
      document.getElementById('ewbNwrOverlay').classList.add('active');
      document.getElementById('ewbNwrTooltip').classList.add('active');
    },
    
    closeNWRInfo: function() {
      document.getElementById('ewbNwrOverlay').classList.remove('active');
      document.getElementById('ewbNwrTooltip').classList.remove('active');
    },
    
    copyEmail: function() {
      navigator.clipboard.writeText('info@gunsofkosta.de').then(() => {
        const toast = document.getElementById('ewbToast');
        toast.classList.add('active');
        setTimeout(() => {
          toast.classList.remove('active');
        }, 2000);
      });
    }
  };

  // ============================================
  // AUTO-INIT (Event Delegation für dynamische Inhalte)
  // ============================================
  
  // Event Delegation - funktioniert auch für später geladene Elemente
  document.addEventListener('click', function(e) {
    // Prüfen ob das geklickte Element oder ein Elternelement ein Trigger ist
    const trigger = e.target.closest('[data-ewb-trigger], .ewb-accordion-trigger, [href*="ewb-konfigurator"], a[href="#"][onclick*="EWBFinder"]');
    
    if (trigger) {
      e.preventDefault();
      EWBFinder.open();
      return;
    }
    
    // Auch Links mit "EWB-Konfigurator" Text abfangen
    if (e.target.tagName === 'A' && e.target.textContent.toLowerCase().includes('ewb-konfigurator')) {
      e.preventDefault();
      EWBFinder.open();
    }
  });

})();
